<template>
  <div>
    <app-cells><h1 class="title">Payment requests </h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ReservationPaymentRequestsLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'reservation-payment-requests', label: 'Payment requests' },
        { name: 'reservation-payment-requests-hotels', label: 'Hotels' },
        { name: 'reservation-payment-requests-flights', label: 'Flights' },
        { name: 'reservation-payment-requests-meals', label: 'Meals' },
        { name: 'reservation-payment-requests-analytics', label: 'Analytics' },
      ],
    }
  },
}
</script>
